import { defaultAttachmentTypeLabelMap } from '../enums.mjs';

const ZOD_INVALID_ENUM_OPTION_PREFIX = "Invalid option: expected one of";
const formatFileTypeLabel = (type) => defaultAttachmentTypeLabelMap[type] ??
    type
        .split("_")
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(" ");
const formatUnsupportedFileTypesMessage = (invalidTypes, sectionLabel = "Financial Documents") => {
    const labels = invalidTypes.map(formatFileTypeLabel);
    if (labels.length === 1) {
        return `This file was classified as "${labels[0]}", which isn't accepted in ${sectionLabel}. Remove the file or upload it in the appropriate section.`;
    }
    return `This file includes document types that aren't accepted in ${sectionLabel}: ${labels.join(", ")}. Remove the file or upload them in the appropriate section.`;
};
const humanizeFileValidationMessage = (message) => {
    if (message.startsWith(ZOD_INVALID_ENUM_OPTION_PREFIX)) {
        return "This file includes a document type that isn't accepted here. Remove the file or upload it in the appropriate section.";
    }
    return message;
};

export { formatFileTypeLabel, formatUnsupportedFileTypesMessage, humanizeFileValidationMessage };
